import axios from "axios";

const axiosInstance = axios.create({
  baseURL: "https://chinet.org/wp-json/api",
  headers: {
    "CHI-Auth": "ae7439ae51ef5cf7d174f1603a459471"
  }
});

export const api = {
  get(endpoint) {
    return axiosInstance.get(endpoint);
  }
};
